import React from 'react';

const PasswordRecoveryView = (props) => {
    return(<div>Password Recovery View</div>)
}

export default PasswordRecoveryView;